import { SERVICES } from "../data";

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="section bg-[var(--bg-2)]">
    <div className="wrap">
      <span className="eyebrow">Os nossos serviços</span>
      <h2 className="h2 mt-5 max-w-2xl">Do quadro elétrico à máquina parada.</h2>
      <div className="services-grid mt-14">
        {SERVICES.map(({ icon: I, title, text }, i) => (
          <article key={title} data-testid={`service-card-${i + 1}`} className="service-card">
            <div className="flex items-start justify-between">
              <div className="icon-box"><I size={22} /></div>
            </div>
            <h3 className="font-display uppercase text-2xl font-bold mt-8 leading-tight">{title}</h3>
            <p className="mt-3 text-[var(--muted)]">{text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
